import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Modal from "./Modal";

const ModalThumbnail = styled.img`
  border-radius: 5px;
`;

class ImageModal extends Component {
  static propTypes = {
    alt: PropTypes.string,
    caption: PropTypes.string,
    src: PropTypes.string.isRequired
  };

  state = {
    isOpen: false
  };

  componentDidMount() {
    document.addEventListener("keydown", this.onEscape);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.onEscape);
  }

  onEscape = ({ keyCode }) => {
    if (keyCode === 27) {
      this.closeLightbox();
    }
  };

  openLightbox = () => this.setState({ isOpen: true });

  closeLightbox = () => this.setState({ isOpen: false });

  render() {
    return (
      <div>
        <ModalThumbnail
          src={this.props.src}
          alt={this.props.alt}
          onClick={this.openLightbox}
        />
        <p className="heading">{this.props.caption}</p>
        <Modal
          isActive={this.state.isOpen}
          onClick={this.closeLightbox}
          style={{ width: "auto", maxWidth: "80vw", overflow: "hidden" }}
        >
          <div>
            <img src={this.props.src} alt={this.props.alt} />
            <p className="heading" style={{ color: "white" }}>
              {this.props.caption}
            </p>
          </div>
        </Modal>
      </div>
    );
  }
}

export default ImageModal;



// WEBPACK FOOTER //
// ./src/components/ImageModal.js